import React from 'react';

import { Box, Tab, Tabs } from 'components';
import { useIsMobile } from 'hooks';

import { EmailDesigner } from './EmailDesigner/EmailDesigner';
import { GeneralSettings } from './GeneralSettings';

import { useTranslation } from 'third-party';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const a11yProps = (index: number) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

export const Settings = () => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={t('settings.tab')} {...a11yProps(0)} />
          {!isMobile && (
            <Tab label={t('emailDesigner.tab')} {...a11yProps(1)} />
          )}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <GeneralSettings />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <EmailDesigner />
      </CustomTabPanel>
    </Box>
  );
};
